import React from 'react';
import { MessageCircle } from 'lucide-react';
export function CTASection() {
  return <section className="py-24 bg-slate-900 relative overflow-hidden" data-id="element-14">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-emerald-900/10 skew-x-12 transform origin-top" data-id="element-15"></div>
      <div className="absolute bottom-0 left-0 w-1/3 h-full bg-blue-900/10 -skew-x-12 transform origin-bottom" data-id="element-16"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-17">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-18">
          Ready to Grow Your Business?
        </h2>
        <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto" data-id="element-19">
          Stop guessing and start growing. Get in touch today for a free
          consultation and let's build your success story together.
        </p>

        <a href="https://wa.me/447921876472" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-emerald-500 text-white px-8 py-5 rounded-full font-bold text-xl hover:bg-emerald-600 transition-all hover:scale-105 shadow-lg hover:shadow-emerald-500/30" data-id="element-20">
          <MessageCircle className="w-6 h-6 fill-current" data-id="element-21" />
          Chat on WhatsApp
        </a>
        <p className="mt-6 text-sm text-slate-400" data-id="element-22">
          Fast response • No obligation • Free audit
        </p>
      </div>
    </section>;
}